/* AlbakiReads BISAC: keep the full collection template in place during pagination.
 * XCloud owns filtered products/facets. Fetch its filtered product-grid section
 * instead of following pagination <a> links to its /a/search/ full-page proxy.
 * Never replace the sidebar/filter root, title, carousels or featured banner.
 */
(function () {
  'use strict';
  if (window.__albakiBisacPaginationLoaded) return;
  window.__albakiBisacPaginationLoaded = true;

  var inflight = null;
  var sequence = 0;
  var usedAjaxPager = false;
  var displayedPage = null;

  function root() {
    return document.querySelector('.akbisac-catalog[data-albaki-catalog]');
  }

  function pageNumber(value) {
    if (!/^[1-9][0-9]*$/.test(String(value || ''))) return null;
    var n = Number(value);
    return Number.isSafeInteger(n) ? n : null;
  }

  function pageInUrl(input) {
    try {
      return pageNumber(new URL(input, location.href).searchParams.get('page')) || 1;
    } catch (e) { return 1; }
  }

  function requestFor(page) {
    var catalog = root();
    if (!catalog) return null;
    var handle = catalog.getAttribute('data-albaki-collection-handle');
    if (!handle) return null;

    /* Preserve filters, selected sort, preview theme ID and currency/locale. */
    var url = new URL(location.href);
    var path = url.pathname;
    var match = path.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections|a\/search)\/[^/?#]+\/?$/i);
    if (!match) return null;
    url.pathname = path.replace(/\/(?:collections|a\/search)\/[^/?#]+\/?$/i,
      '/a/search/' + encodeURIComponent(handle));
    url.searchParams.set('page', String(page));
    url.searchParams.set('cloud_search_section_id', 'product-grid');
    url.hash = '';
    return url;
  }

  function publicUrlFor(page) {
    var url = new URL(location.href);
    url.pathname = url.pathname.replace(/\/a\/search\//i, '/collections/');
    url.searchParams.delete('cloud_search_section_id');
    if (page === 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    if (url.hash === '#albaki-catalog') url.hash = '';
    return url.pathname + url.search + url.hash;
  }

  function report(message, detail) {
    if (window.console && console.warn) console.warn('[Albaki BISAC pagination] ' + message, detail || '');
  }

  function setBusy(value) {
    var container = root() && root().querySelector('#ProductGridContainer');
    if (container) {
      if (value) container.setAttribute('aria-busy', 'true');
      else container.removeAttribute('aria-busy');
    }
  }

  function scrollToCatalog() {
    var catalog = root();
    if (!catalog) return;
    var top = Math.max(0, window.scrollY + catalog.getBoundingClientRect().top - 112);
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduced ? 'instant' : 'smooth' });
  }

  async function loadPage(page, historyMode, silent) {
    var request = requestFor(page);
    if (!request) return;
    var mySequence = ++sequence;
    if (inflight) inflight.abort();
    inflight = new AbortController();
    var signal = inflight.signal;
    var stateAtRequest = new URL(location.href);
    stateAtRequest.searchParams.delete('page');
    stateAtRequest.searchParams.delete('cloud_search_section_id');
    var originalStateKey = stateAtRequest.pathname + '?' + stateAtRequest.searchParams.toString();
    setBusy(true);

    try {
      var response = await fetch(request.href, {
        credentials: 'same-origin',
        signal: signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var section = doc.getElementById('shopify-section-product-grid');
      if (!section) throw new Error('XCloud product-grid section not found');
      var nextGrid = section.querySelector('#product-grid');
      if (!nextGrid) throw new Error('XCloud response did not contain #product-grid');

      var countEl = section.querySelector('[data-albaki-results-count]');
      var count = countEl ? Number(countEl.getAttribute('data-albaki-results-count')) : NaN;
      var cloudData = section.parentElement && doc.getElementById('cloudsearch-data');
      var cloudTotal = null;
      if (cloudData) {
        try { cloudTotal = JSON.parse(cloudData.textContent).total; } catch (e) {}
      }
      if (!nextGrid.children.length && (count > 0 || cloudTotal > 0)) {
        throw new Error('XCloud response has a nonzero count but no cards');
      }

      var currentState = new URL(location.href);
      currentState.searchParams.delete('page');
      currentState.searchParams.delete('cloud_search_section_id');
      var currentStateKey = currentState.pathname + '?' + currentState.searchParams.toString();
      if (signal.aborted || mySequence !== sequence || currentStateKey !== originalStateKey) return;

      var catalog = root();
      var currentGrid = catalog && catalog.querySelector('#product-grid');
      if (!currentGrid) return;
      var currentContainer = catalog.querySelector('#ProductGridContainer');
      var oldPager = currentContainer.querySelector('.pagination-wrapper');
      var nextPager = section.querySelector('#ProductGridContainer .pagination-wrapper');
      var currentCount = currentContainer.querySelector('[data-albaki-results-count]');
      var nextEmpty = section.querySelector('#ProductGridContainer .collection--empty');
      var oldEmpty = currentContainer.querySelector('.collection--empty');

      /* Replace ONLY cards, pagination, count and optional empty message. */
      currentGrid.replaceWith(document.importNode(nextGrid, true));
      if (oldPager && nextPager) oldPager.replaceWith(document.importNode(nextPager, true));
      else if (oldPager) oldPager.remove();
      else if (nextPager) currentContainer.appendChild(document.importNode(nextPager, true));
      if (oldEmpty) oldEmpty.remove();
      if (nextEmpty) currentContainer.insertBefore(document.importNode(nextEmpty, true), currentContainer.querySelector('#product-grid'));
      if (currentCount && countEl) {
        currentCount.setAttribute('data-albaki-results-count', countEl.getAttribute('data-albaki-results-count'));
        currentCount.textContent = countEl.textContent;
      }

      displayedPage = page;
      if (historyMode === 'push') {
        var oldState = history.state;
        var newState = oldState && typeof oldState === 'object' ? Object.assign({}, oldState) : {};
        newState.albakiBisacAjaxPage = true;
        history.pushState(newState, '', publicUrlFor(page));
        usedAjaxPager = true;
      }
      if (!silent) scrollToCatalog();
    } catch (error) {
      if (error.name !== 'AbortError') report('Section request failed; leaving the current page intact.', error.message);
    } finally {
      if (mySequence === sequence) { inflight = null; setBusy(false); }
    }
  }

  /* A bookmarked/refresh URL can contain XCloud-only sort, facet or page
     parameters. Stay on the real Shopify BISAC collection template; fetch
     the exact XCloud product-grid section in the background (same mechanism
     used for ordinary AJAX page clicks). Never push history or auto-scroll.
     The page's existing XCloud script still owns sidebar facet interactions. */
  function hasInitialXCloudState() {
    var path = location.pathname;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/?#]+\/?$/i.test(path)) return false;
    var parameters = new URLSearchParams(location.search);
    var active = false;
    parameters.forEach(function (_value, key) {
      if (key === 'page' || key === 'sort_by' ||
          key.indexOf('filter_') === 0 || key.indexOf('filter[') === 0) active = true;
    });
    return active;
  }

  /* XCloud's selected facet controls are initialized from its /a/search page,
     not from a plain Shopify /collections/ server render. Our AJAX grid
     hydration already restores the correct products, but it does not hydrate
     XCloud's in-memory checkbox/active-chip state. Use the app's OWN native
     controls to restore that state. Do not create fake badges or change the
     underlying product source. Scoped exclusively to BISAC bookmarked URLs. */
  function waitFor(test, timeout) {
    return new Promise(function (resolve) {
      var start = Date.now();
      function tick() {
        var value = null;
        try { value = test(); } catch (e) {}
        if (value) return resolve(value);
        if (Date.now() - start >= (timeout || 5000)) return resolve(null);
        setTimeout(tick, 90);
      }
      tick();
    });
  }

  function cleanFacetText(value) {
    return String(value || '').replace(/\u200b/g, '').replace(/\s*\([\d,]+\)\s*$/, '')
      .replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function nativeGroup(id) {
    var sidebar = document.getElementById('cloud_search_filters_sidebar');
    if (!sidebar) return null;
    var candidates = Array.prototype.slice.call(sidebar.querySelectorAll('[data-filter-name]'));
    return candidates.find(function (el) {
      return cleanFacetText(el.getAttribute('data-filter-name')) === cleanFacetText(id);
    }) || null;
  }

  function nativeFacetOption(group, desired) {
    if (!group) return null;
    var labels = Array.prototype.slice.call(group.querySelectorAll('label, [data-filter-value]'));
    var target = cleanFacetText(desired);
    var label = labels.find(function (item) {
      var value = cleanFacetText(item.getAttribute('data-filter-value'));
      if (value && value === target) return true;
      var field = item.querySelector('input[type="checkbox"],input[type="radio"]');
      return field && cleanFacetText(item.textContent) === target;
    });
    if (label) {
      return { control: label.querySelector('input[type="checkbox"],input[type="radio"]') || label,
        checked: function () {
          var input = label.querySelector('input[type="checkbox"],input[type="radio"]');
          return !!(input && input.checked);
        } };
    }
    /* XCloud sometimes renders controls with their label as a sibling. */
    var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"],input[type="radio"]'));
    var input = inputs.find(function (field) {
      var host = field.closest('label,[data-filter-value]') || field.parentElement;
      var text = host ? host.textContent : field.getAttribute('aria-label');
      return cleanFacetText(text) === target || cleanFacetText(field.getAttribute('aria-label')) === target;
    });
    return input ? { control: input, checked: function () { return input.checked; } } : null;
  }

  function nativeSortOption(key) {
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-filter-name]'));
    var group = all.find(function (el) {
      return cleanFacetText(el.getAttribute('data-filter-name')) === 'sort by';
    });
    if (!group) return null;
    var choice = Array.prototype.slice.call(group.querySelectorAll('[data-filter-value]')).find(function (el) {
      return el.getAttribute('data-filter-value') === key;
    });
    if (!choice) return null;
    var input = choice.querySelector('input');
    return { control: input || choice, checked: function () { return !!(input && input.checked); } };
  }

  function nativeFacetForParameter(name, value) {
    if (name === 'sort_by') return nativeSortOption(value);
    var facetName, selectedValue = value;
    var availability = name.match(/^filter_availability\[([^\]]+)\]$/);
    if (availability) {
      if (value !== 'true') return null;
      facetName = 'availability';
      selectedValue = availability[1].replace(/_/g, ' ');
    } else {
      var facet = name.match(/^filter_([a-z\d_\-]+)$/i);
      if (!facet) return null;
      facetName = facet[1];
    }
    return nativeFacetOption(nativeGroup(facetName), selectedValue);
  }

  async function restoreNativeXCloudState(bookmark) {
    var desired = [];
    bookmark.searchParams.forEach(function (value, name) {
      if (name === 'sort_by' && value && value !== 'on') return; /* sort LAST */
      if (name.indexOf('filter_') === 0) desired.push({ name: name, value: value });
    });
    var sort = bookmark.searchParams.get('sort_by');
    if (sort && sort !== 'on') desired.push({ name: 'sort_by', value: sort });
    if (!desired.length) return;

    /* Wait for XCloud to render its real sidebar; do not manipulate inputs
       until its own event handlers have been attached. */
    var ready = await waitFor(function () {
      return document.querySelector('#cloud_search_filters_sidebar [data-filter-name] input') && root();
    }, 7500);
    if (!ready) {
      report('XCloud controls were not ready to restore the selected filters.');
      return;
    }
    for (var i = 0; i < desired.length; i++) {
      var item = desired[i];
      var choice = await waitFor(function () {
        return nativeFacetForParameter(item.name, item.value);
      }, 2500);
      /* Sort options may be lazy-created when its native heading opens. */
      if (!choice && item.name === 'sort_by') {
        var group = Array.prototype.slice.call(document.querySelectorAll('[data-filter-name]')).find(function (el) {
          return cleanFacetText(el.getAttribute('data-filter-name')) === 'sort by';
        });
        var heading = group && (group.querySelector('.cloud-search-filter__name') || group.firstElementChild);
        if (heading) heading.click();
        choice = await waitFor(function () { return nativeFacetForParameter(item.name, item.value); }, 1600);
      }
      if (!choice) {
        report('XCloud native option not found for bookmarked filter', item.name + '=' + item.value);
        continue;
      }
      if (!choice.checked()) {
        /* This activates XCloud's own state machine, badges, URLs and AJAX.
           Setting .checked=true directly would only imitate the appearance. */
        choice.control.click();
        await waitFor(function () {
          var next = nativeFacetForParameter(item.name, item.value);
          return next && next.checked();
        }, 2000);
        /* Allow XCloud's async facet reconciliation before applying the next.
           Each subsequent selection must see the previous selected facet. */
        await new Promise(function (resolve) { setTimeout(resolve, 750); });
      }
    }
  }

  async function restoreBookmarkedPage() {
    if (!root() || !hasInitialXCloudState()) return;
    var initial = new URL(location.href);
    /* Protect the original deep link while XCloud initializes its own selected
       state. Afterwards restore page/sort/filter params and load that page.
       Do not add browser history entries or jump the user's scroll position. */
    try {
      await restoreNativeXCloudState(initial);
    } catch (e) {
      report('Native facet initialization failed; restoring product grid anyway.', e.message);
    }
    if (!root()) return;
    history.replaceState(history.state, '', initial.pathname + initial.search + initial.hash);
    loadPage(pageInUrl(initial.href), 'none', true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreBookmarkedPage, { once: true });
  } else {
    restoreBookmarkedPage();
  }

  /* Capture before the browser or an app can follow a pagination anchor. */
  window.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var node = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
    var link = node && node.closest && node.closest('.akbisac-catalog .pagination-wrapper a[href]');
    if (!link || !root() || !root().contains(link)) return;
    var page = pageNumber(new URL(link.href, location.href).searchParams.get('page'));
    if (!page) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    loadPage(page, 'push');
  }, true);

  /* Back/Forward between pages visited via our AJAX paginator. */
  window.addEventListener('popstate', function () {
    if (!usedAjaxPager || !root()) return;
    var page = pageInUrl(location.href);
    if (page === displayedPage) return;
    loadPage(page, 'none');
  });
})();
